import { render, staticRenderFns } from "./wtImageAsset.vue?vue&type=template&id=4cfbe8a8&"
import script from "./wtImageAsset.vue?vue&type=script&lang=js&"
export * from "./wtImageAsset.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports